import { useAuth } from '../../../contexts/UserContext';
import { Container, Hr1 } from './styles';
import { IconUsers, IconProfessional, IconServices, IconSquarePlus } from '../../icons';
import { comum } from '../../../styles/Themes/light';

export default function Etapas({activePage}: {activePage: number}) {

    const { user } = useAuth();

    const steps = [
        {
            title: 'Step 1',
            description: 'Description 1',
        },
        {
            title: 'Step 2',
            description: 'Description 2',
        },
    ];

    return (
        <Container>
            <div className="status">
                    <Hr1
                        className={
                            activePage === 1 ? "first" : 
                            activePage === 2 ? "second" : 
                            activePage === 3 ? "third" : 
                            activePage === 4 ? 'fourth' : ''
                        }
                    />
                    <div
                        className="status-square first"
                    >
                        <div className={"square active"}>
                            <IconServices color={comum.colors.primaryRed400} />
                        </div>
                        <p className="first">Serviço</p>
                    </div>
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 1 ? "square active" : 'square'}>
                            <IconUsers />
                        </div>
                        <p className={activePage > 1 ? 'on second' : 'second'} >Partes</p>
                    </div>
                    {
                        user.profile !== 'Solicitante' &&
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 2 ? "square active" : 'square'}>
                            <IconProfessional />
                        </div>
                        <p className={activePage > 2 ? 'on third' : 'third'} >Profissional</p>
                    </div>
                    }
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 3 ? "square active" : 'square'}>
                            <IconSquarePlus />
                        </div>
                        <p className={activePage > 3 ? 'on fourth' : 'fourth'} >Demanda</p>
                    </div>
                </div>
        </Container>
    )
}